import { Pipe, PipeTransform } from '@angular/core'
import { Duration } from 'date-fns'

@Pipe({
  name: 'countdownClockStyle',
  standalone: true,
})
export class CountdownClockstyleTostringPipe implements PipeTransform {
  transform(value: Duration): string {
    const showMinutes = !!value.minutes || !!value.hours
    const showSecondsLabel = !showMinutes
    const pad = (n: number) => n.toString().padStart(2, '0')
    return `${value.hours ? pad(value.hours) + ':' : ''}${showMinutes ? pad(value.minutes || 0) + ':' : ''}${pad(value.seconds || 0) + (showSecondsLabel ? ' sec' : '')}`
  }
}
